module.exports = __webpack_public_path__ + "static/media/pc-image-background-checker-pattern-red-2.ab198049.svg";